export default {
  editFontSize: 13,
  defaultFontSize: 13,
  fontFamily: '"Lato", sans-serif',
  fieldBorderLight: '1px solid #f1f1f1',
  fieldBorderMedium: '1px solid #d9d9d9',
  darkLinkColor: '#333333',
  linkColor: '#4baef8',
  linkColorHighlight: '#2d95e3',
  buttonBorder: '2px solid #4baef8',
  buttonBorderHighlight: '2px solid #2d95e3',
  sectionTitleBackground: 'linear-gradient(to bottom, #ffffff 0%,#207cca 0%,#ffffff 0%,#f2f2f2 100%)',
  sectionTitleBackgroundHover: 'linear-gradient(to bottom, #ffffff 0%,#207cca 0%,#ffffff 0%,#e7e7e7 100%)',
};
